import { useState, useRef } from "react";
import { motion, AnimatePresence, PanInfo } from "framer-motion";
import { Users, Flame } from "lucide-react";
import PopularPosts from "@/components/PopularPosts";
import FriendsFeed from "@/components/FriendsFeed";

type FeedTab = "foryou" | "friends";

const MobileFeedTabs = () => {
  const [activeTab, setActiveTab] = useState<FeedTab>("foryou");
  const containerRef = useRef<HTMLDivElement>(null);

  const handleDragEnd = (_: any, info: PanInfo) => {
    if (info.offset.x > 80 && activeTab === "foryou") {
      setActiveTab("friends");
    } else if (info.offset.x < -80 && activeTab === "friends") {
      setActiveTab("foryou");
    }
  };

  return (
    <div className="relative">
      {/* Tab indicators — sticky below navbar */}
      <div className="sticky top-[72px] z-30 bg-background/80 backdrop-blur-xl border-b border-border/30">
        <div className="flex items-center justify-center gap-8 py-2.5">
          <button
            onClick={() => setActiveTab("friends")}
            className={`flex items-center gap-1.5 text-sm font-display font-semibold transition-colors ${
              activeTab === "friends" ? "text-foreground" : "text-muted-foreground"
            }`}
          >
            <Users className="h-3.5 w-3.5" />
            Friends
          </button>
          <button
            onClick={() => setActiveTab("foryou")}
            className={`flex items-center gap-1.5 text-sm font-display font-semibold transition-colors ${
              activeTab === "foryou" ? "text-foreground" : "text-muted-foreground"
            }`}
          >
            <Flame className="h-3.5 w-3.5" />
            For You
          </button>
        </div>
        {/* Active indicator line */}
        <div className="relative h-0.5 mx-auto w-48">
          <motion.div
            className="absolute top-0 h-full w-1/2 rounded-full bg-primary"
            animate={{ x: activeTab === "friends" ? 0 : "100%" }}
            transition={{ type: "spring", stiffness: 300, damping: 30 }}
          />
        </div>
      </div>

      {/* Swipeable feed content */}
      <motion.div
        ref={containerRef}
        drag="x"
        dragConstraints={{ left: 0, right: 0 }}
        dragElastic={0.2}
        onDragEnd={handleDragEnd}
        className="touch-pan-y"
      >
        <AnimatePresence mode="wait">
          {activeTab === "foryou" ? (
            <motion.div
              key="foryou"
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: 50 }}
              transition={{ duration: 0.25 }}
            >
              <PopularPosts />
            </motion.div>
          ) : (
            <motion.div
              key="friends"
              initial={{ opacity: 0, x: -50 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -50 }}
              transition={{ duration: 0.25 }}
            >
              <FriendsFeed />
            </motion.div>
          )}
        </AnimatePresence>
      </motion.div>
    </div>
  );
};

export default MobileFeedTabs;
